import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

import AccessoriesSkus from '../../components/AccessoriesSkus'

export default defineType({
  name: 'lugBoltsStudsConfiguration',
  title: 'Lug Bolts & Studs Configuration',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      title: 'Lug Bolts Message.',
      name: 'lugBoltsMessage',
      type: 'string',
    }),
    defineField({
      title: 'Lug Bolts Details Modal',
      name: 'lugBoltsDetailsModal',
      type: 'reference',
      to: [{ type: 'modal' }],
    }),
    defineField({
      title: 'Studs Message.',
      name: 'studsMessage',
      type: 'string',
    }),
    defineField({
      title: 'Studs Details Modal',
      name: 'studsDetailsModal',
      type: 'reference',
      to: [{ type: 'modal' }],
    }),
    defineField({
      title: 'Required?',
      name: 'required',
      type: 'boolean',
      initialValue: false,
    }),
    defineField({
      title: 'Important Message',
      name: 'importantMessage',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      name: 'skus',
      title: 'Product SKUs',
      description: 'Comma separated skus can be used for searching',
      type: 'string',
      components: {
        input: AccessoriesSkus,
      },
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({ title = 'New Configuration' }) {
      return {
        title,
        subtitle: 'Lug Bolts & Studs Configuration',
      }
    },
  },
})
